import { useEffect } from 'react';
import { Header } from "semantic-ui-react";

const UpdateComplete = (props) => {
    const getTerm = props.getTerm;

    useEffect(() => {
        // This code runs only once after the component mounts
        if (window.parent) {
            window.parent.postMessage("Update Complete", "*");
        }
    }, []);


    return (
        <div>
            <Header as='h2'>{getTerm("2f28cd0c-dab6-11f0-9cd9-0ac9221eb135", "Update Complete")}</Header>
            <div dangerouslySetInnerHTML={{__html: getTerm("631cd338-dab6-11f0-9cd9-0ac9221eb135", '<p><strong>Thank you! You have successfully updated your information..</strong></p><br /><p>For ADP Technical Support, please contact <a href="https://help.iatfadp.com/" target="_blank">help.iatfadp.com</a>. For inquiries related to your ADP sponsorship status, please contact your CB.</p><br /><p><a href="http://www.iatfglobaloversight.org">IATF Global Oversight Website</a></p>')}}>
                {/* <p><strong>Thank you! You have successfully updated your information.</strong></p>

                <br /><p>For ADP Technical Support, please contact <a href="https://help.iatfadp.com/" target="_blank">help.iatfadp.com</a>.  For inquiries related to your ADP sponsorship status, please contact your CB.</p>

                <br /><p><a href="http://www.iatfglobaloversight.org">IATF Global Oversight Website</a></p> */}
            </div>

        </div>
    )
}

export default UpdateComplete;